import React, { useEffect, useState } from 'react';
import { VentaCafeteria, FacturacionVenta, fetchFacturacionVenta, emitirFacturaVenta } from '../../../services/ventaCafeteriaService';
import { descargarPDFFactura, descargarXMLFactura, imprimirFactura } from '../../../services/facturacionService';

export default function FacturaCafeteria({ venta, operadorToken }: { venta: VentaCafeteria; operadorToken?: string | null }) {
  const [data, setData] = useState<FacturacionVenta | null>(null);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    let active = true;
    fetchFacturacionVenta(venta.id).then(value => { if (active) setData(value); })
      .catch(() => { if (active) setError('No se pudo consultar la factura.'); });
    return () => { active = false; };
  }, [venta.id]);
  const run = async (action: () => Promise<unknown>) => {
    setBusy(true); setError('');
    try { await action(); } catch (e: any) { setError(e.response?.data?.detail || e.message || 'No se pudo completar la operación.'); }
    finally { setBusy(false); }
  };
  const factura = data?.factura;
  const button = 'rounded-lg border border-slate-200 px-3 py-2 text-sm font-semibold text-[#3564db] disabled:opacity-50';
  return <section className="mt-4 rounded-xl border border-slate-200 bg-slate-50 p-4" aria-label="Factura de cafetería">
    <h3 className="font-bold text-slate-800">Factura {factura?.numero_factura ? `N.º ${factura.numero_factura}` : 'de cafetería'}</h3>
    <p className="my-2 text-sm text-slate-600">{factura ? `Estado: ${factura.estado}` : data ? (Number(venta.saldo_pendiente) > 0 ? 'Se emitirá al completar el pago.' : 'Pendiente de emisión.') : 'Consultando factura…'}</p>
    {data?.detalle && <p role="status" className="my-2 text-sm text-amber-800">{data.detalle}</p>}
    {factura?.mensajes_siat?.length ? <p className="my-2 text-sm text-amber-800">{factura.mensajes_siat.map(m => m.descripcion || m.codigo).join(' · ')}</p> : null}
    {error && <p role="alert" className="my-2 text-sm text-red-700">{error}</p>}
    <div className="flex flex-wrap gap-2">
      <button disabled={busy} className={button} onClick={() => run(async () => setData(await fetchFacturacionVenta(venta.id)))}>Actualizar estado</button>
      {factura?.estado === 'validada' && <>
        <button disabled={busy} className={button} onClick={() => run(() => imprimirFactura(factura.id))}>Imprimir</button>
        <button disabled={busy} className={button} onClick={() => run(() => descargarPDFFactura(factura.id, 'carta'))}>PDF carta</button>
        <button disabled={busy} className={button} onClick={() => run(() => descargarPDFFactura(factura.id, 'rollo'))}>PDF rollo</button>
        <button disabled={busy} className={button} onClick={() => run(() => descargarXMLFactura(factura.id))}>XML</button>
      </>}
      {data && Number(venta.saldo_pendiente) === 0 && (!factura || !['validada', 'anulada'].includes(factura.estado)) &&
        <button disabled={busy} className={button} onClick={() => run(async () => setData(await emitirFacturaVenta(venta.id, operadorToken)))}>Reintentar emisión</button>}
    </div>
  </section>;
}

